import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-show-text',
    template: `
      <app-show-layout [strong]='strong' [label]="label">
        <span *ngIf="value">
          {{ value }}
        </span>
        <span *ngIf="!value">
          <em class="text-secondary">Non presente</em>
        </span>
      </app-show-layout>
  `,
    standalone: false
})
export class ShowTextComponent {

  @Input() label;
  @Input() value;
  @Input() strong = true;
}
